module.exports = __webpack_public_path__ + "static/media/logo.8302c414.png";